<template>
  <div class="success">
    <div>
      <table class="tbl">
        <tr>
          <th class="txt-left">
            TARIFA
          </th>
          <th class="txt-left">
            BASE
          </th>
          <th class="txt-left">
            BUS
          </th>
          <th>PASAJERO</th>
          <th>DNI</th>
          <th class="txt-right">
            <span class="span-ceara">VALOR</span>
          </th>
        </tr>
        <tr
          v-for="(pax, i) in reservation.passengers"
          :key="'pax' + i"
        >
          <td class="txt-left">
            {{ reservation.rate.detail }}
          </td>
          <td class="txt-left">
            {{ pax.fee_es }}
          </td>
          <td class="txt-left">
            {{ pax.seat_categ_str }}
          </td>
          <td>
            {{ pax.alt }} <small v-if="pax.main"><strong>(titular)</strong></small>
          </td>
          <td>{{ pax.ident || '-' }}</td>
          <td class="txt-right">
            {{ pax.seat_price ? price.currency : '' }}{{ pax.seat_price || ' -' }}
          </td>
        </tr>
      </table>
      <table class="tbl">
        <tr v-if="price.promo_discount || price.service_discount">
          <th
            class="txt-left"
            colspan="6"
          >
            DESCUENTOS
          </th>
        </tr>
        <tr v-if="price.promo_discount">
          <td
            class="txt-left"
            colspan="5"
          >
            {{ price.promo_description }}
          </td>
          <td class="txt-right">
            -{{ price.currency }}{{ price.promo_discount }}
          </td>
        </tr>
        <tr v-if="price.service_discount">
          <td
            class="txt-left"
            colspan="5"
          >
            {{ price.service_description }}
          </td>
          <td class="txt-right">
            -{{ price.currency }}{{ price.service_discount }}
          </td>
        </tr>
        <tr>
          <th
            colspan="6"
            class="txt-right"
          >
            <span class="mr-3">SUBTOTAL</span> {{ price.currency }}{{ price.subtotal }}
          </th>
        </tr>
        <tr>
          <td
            class="txt-left"
            colspan="5"
          >
            COMISIÓN AGENCIA
          </td>
          <td class="txt-right">
            {{ price.currency }}{{ price.commission }}
          </td>
        </tr>
        <tr>
          <td
            class="txt-left"
            colspan="5"
          >
            GASTOS BANCARIOS
          </td>
          <td class="txt-right">
            {{ price.currency }}{{ price.bank_taxes }}
          </td>
        </tr>
        <tr
          v-for="(revocation, i) in revocations.filter(r => !r.commissionable)"
          :key="i"
        >
          <td class="txt-left">
            {{ revocation.description }}
          </td>
          <td class="txt-right">
            {{ price.currency }}{{ revocation.price }}
          </td>
        </tr>
      </table>
      <table class="tbl">
        <tr>
          <th class="txt-left">
            DESTINO
          </th>
          <th>RESERVA</th>
          <th>CANT. PASAJEROS</th>
          <th>SEÑA</th>
          <th>VENCIMIENTO</th>
          <th class="txt-right">
            <span class="span-ceara">TOTAL</span>
          </th>
        </tr>
        <tr>
          <td class="txt-left">
            {{ departure.alias }} {{ departure.name }}
          </td>
          <td>{{ price.reservation_id }}</td>
          <td>{{ passengers.length }}</td>
          <td>{{ price.currency }}{{ price.partial }}</td>
          <td>{{ expiration }}</td>
          <td class="txt-right">
            <strong>{{ price.currency }}{{ price.final }}</strong>
          </td>
        </tr>
      </table>
    </div>
    <div class="txt-center py-2 border-top my-3">
      <btn
        color="black"
        size="xs"
        target="_blank"
        :href="
          '/payments?code=' +
            reservation.id +
            '&amount=' +
            price.final +
            '&agency=' +
            $store.state.user.email
        "
      >
        PAGO ONLINE
      </btn>
    </div>
  </div>
</template>
<script>
import Btn from '@/components/Btn'
import { yyyymmdd_ddmmyyy } from '@/utils'

export default {
  components: { Btn },

  props: ['reservation'],

  computed: {
    expiration () {
      return yyyymmdd_ddmmyyy(this.price.expiration)
    },
    revocations () {
      return this.reservation.revocations
    },
    departure () {
      return this.reservation.departure
    },
    price () {
      return this.reservation.price
    },
    passengers () {
      return this.reservation.passengers
    }
  },

  methods: {
    print () {
      window.print()
    }
  }
}
</script>
